/**
 * Holds below-the-fold images out of the LCP's bandwidth window.
 *
 * loading="lazy" was already on these images and was not enough. Chrome's lazy threshold is a
 * distance from the viewport (and it *grows* on slow connections), so on the mobile homepage the six
 * home-categories tiles at y=900 and the two duo-collections tiles at y=1298/1705 all started
 * downloading at ~2.06 s - measured 2026-08-13, throttled Pixel 5. That is 169 KB sharing a
 * ~200 KB/s pipe with the 50 KB LCP image, which is why the LCP image needed 3.4 s to arrive and the
 * home LCP sat at 5.3 s. The bytes were never the problem; the timing was.
 *
 * So the URLs ship in data-defer-src / data-defer-srcset - an <img> with no src downloads nothing,
 * whatever Chrome thinks of its distance to the viewport - and are put back once the page's own load
 * event has fired, i.e. after the LCP image is in. From that point loading="lazy" governs again as
 * usual: a tile still far below the fold waits, one the visitor has already scrolled to downloads
 * at once.
 *
 * width/height stay on the markup, so the boxes are reserved and this costs no layout shift.
 */
(function () {
  if (window.__mnlDeferImages) return;
  window.__mnlDeferImages = true;

  function hydrate() {
    var imgs = document.querySelectorAll('img[data-defer-src]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var picture = img.parentElement;
      if (picture && picture.tagName === 'PICTURE') {
        var sources = picture.querySelectorAll('source[data-defer-srcset]');
        for (var j = 0; j < sources.length; j++) {
          sources[j].setAttribute('srcset', sources[j].getAttribute('data-defer-srcset'));
          sources[j].removeAttribute('data-defer-srcset');
        }
      }
      if (img.hasAttribute('data-defer-srcset')) {
        img.setAttribute('srcset', img.getAttribute('data-defer-srcset'));
        img.removeAttribute('data-defer-srcset');
      }
      img.setAttribute('src', img.getAttribute('data-defer-src'));
      img.removeAttribute('data-defer-src');
    }
  }

  // Three triggers, one idempotent hydrate: the normal one, a visitor who scrolls before the page
  // has finished loading, and a backstop so a single hung request can never leave the tiles empty.
  if (document.readyState === 'complete') {
    hydrate();
  } else {
    window.addEventListener('load', hydrate, { once: true });
    window.addEventListener('scroll', hydrate, { once: true, passive: true });
    setTimeout(hydrate, 6000);
  }
})();
